import React from 'react';

import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { ConfirmDialog } from '../../../../components/ConfirmDialog';
import { useMutation } from 'react-fetching-library';
import { getEmployeeApplications } from '../../../../services/request';
import { useApplication } from '../ApplicationsContext';

export default function Delete({ rowData }) {
  const ctx = useApplication();
  const { mutate } = useMutation(getEmployeeApplications);
  const [open, setOpen] = React.useState(false);

  const handleDelete = async () => {
    const { error } = await mutate('DELETE', rowData.id);
    if (!error) {
      ctx.query();
    } else {
      alert('Nie udało się usunąć aplikacji');
    }
  };

  return (
    <>
      <Tooltip title="Usuń">
        <IconButton
          color="error"
          onClick={() => setOpen(true)}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
      <ConfirmDialog
        title="Usunąć aplikacje?"
        open={open}
        setOpen={setOpen}
        onConfirm={handleDelete}
      >
        Czy na pewno chcesz usunąć aplikacje pracownika o numerze {rowData.id}?
      </ConfirmDialog>
    </>
  );
};

